import { render, staticRenderFns } from "./DynamicRadio.vue?vue&type=template&id=edda854e&scoped=true"
import script from "./DynamicRadio.vue?vue&type=script&lang=js"
export * from "./DynamicRadio.vue?vue&type=script&lang=js"
import style0 from "./DynamicRadio.vue?vue&type=style&index=0&id=edda854e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edda854e",
  null
  
)

/* custom blocks */
import block0 from "./DynamicRadio.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports